import { FooterBottom } from "./components/FooterBottom";
import { FooterHeader } from "./components/FooterHeader";
import { FooterLinks } from "./components/FooterLinks";
import { FooterLogo } from "./components/FooterLogo";
import { cn } from "@verse_core/shared_components/ClassName";

interface FooterProps {
  hasGradient?: boolean;
  isRounded?: boolean;
  title?: string;
  titleAccent?: string;
  description?: string;
  hasSquiggle?: boolean;
  hasJobOpeningsButton?: boolean;
  buttonText?: string;
  buttonClassName?: string;
}

export function Footer({
  hasGradient,
  isRounded,
  title,
  titleAccent,
  description,
  hasSquiggle,
  hasJobOpeningsButton,
  buttonText,
  buttonClassName,
}: FooterProps) {
  return (
    <div className={cn("tw-w-full", hasGradient && "tw-bg-[#33ADFF]")}>
      <div
        id="footer"
        className={cn(
          "tw-z-2 tw-relative tw-overflow-hidden tw-bg-blue-dark-3 tw-px-[1.25em] min440:tw-px-[4.75em]",
          isRounded && "tw-rounded-t-[4em]",
        )}
      >
        {hasSquiggle && (
          <img
            src="/homepage/footerVector.svg"
            className="tw-absolute tw-right-[-3.4375em] tw-top-[-5.3125em] tw-z-[1] tw-h-[37.5em] tw-w-[25em] tw-rotate-[10deg] min440:tw-right-[-6.875em] min440:tw-top-[-10.625em] min440:tw-h-[50em] min440:tw-w-[31.25em]"
          />
        )}
        <FooterHeader
          title={title}
          titleAccent={titleAccent}
          description={description}
          hasJobOpeningsButton={hasJobOpeningsButton}
          buttonText={buttonText}
          buttonClassName={buttonClassName}
        />
        {!title && (
          <div className="tw-min-h-[4em] tw-w-full tw-bg-blue-dark-3 min440:tw-h-full" />
        )}
        <div className="tw-z-20 tw-flex tw-flex-col tw-flex-wrap tw-items-center tw-justify-between tw-gap-y-[2.625em] tw-rounded-t-[2em] tw-bg-blue-dark-2 tw-px-[1.25em] tw-py-[2.625em] min440:tw-gap-y-[3em] min440:tw-px-[3.75em] min440:tw-py-[4em]">
          <div className="tw-flex tw-w-full tw-flex-wrap tw-items-start tw-justify-between">
            <FooterLogo />
            <FooterLinks />
          </div>
          <FooterBottom />
        </div>
      </div>
    </div>
  );
}
